// extracted by css-extract-rspack-plugin
export default {"page_toggles":"MNdJF","pageToggles":"MNdJF"};